// Shared labelled structural-state grid — explicit semantics, never an
// unlabeled chain of state values. Values are published labels verbatim.
import React from "react";
import { StateChip } from "./TopPatternsTable";

export const StateGrid = ({ items, testId }) => (
    <div className="flex items-start gap-x-6 gap-y-2 flex-wrap" data-testid={testId}>
        {items.filter((i) => i && i.value != null).map((i) => (
            <div key={i.label}>
                <div className="text-[8.5px] uppercase tracking-wider text-[hsl(var(--mute))] mb-0.5">{i.label}</div>
                {i.plain
                    ? <span className="text-[10.5px] text-[hsl(var(--ink-soft))]">{String(i.value).replace(/_/g, " ").toLowerCase()}</span>
                    : <StateChip value={i.value} />}
            </div>
        ))}
    </div>
);
